export const dmarcPassTypeOptions = [
    { display: 'DMARC Pass', key: 'single' },
    { display: 'DMARC Double Pass', key: 'double' }
];
